<template>
    <!-- The product's link to its product on mimikid.lv. Every save of the
         product overwrites that shop product, so the number is shown read only
         once set and changed only on purpose: "Сменить", check what it points
         to, confirm. -->
    <div class="col-md-6">
        <label>ID товара на сайте (OpenCart)</label>

        <!-- Linked, and not being changed -->
        <div v-if="edit && current && !changing" class="d-flex align-items-center mb-3">
            <input type="text" class="form-control round bg-light text-dark" :value="current" readonly style="max-width:160px">
            <button type="button" class="btn btn-light ml-2" @click="startChange">Сменить</button>
        </div>

        <!-- New product, an unlinked one, or a change in progress -->
        <div v-else class="mb-3">
            <div class="d-flex align-items-center">
                <input
                    type="number"
                    min="1"
                    class="form-control round bg-transparent text-dark"
                    style="max-width:160px"
                    :placeholder="edit ? 'ID на сайте' : 'Пусто - создать на сайте'"
                    v-model="value"
                    @input="onInput"
                    @keyup.enter="check"
                >
                <button type="button" class="btn btn-light ml-2" :disabled="!value || busy" @click="check">Проверить</button>
                <button v-if="edit && result && result.ok" type="button" class="btn btn-primary ml-2" :disabled="busy" @click="save">Связать</button>
                <button v-if="edit && current" type="button" class="btn btn-link ml-1" @click="cancelChange">Отмена</button>
            </div>
            <small v-if="!edit" class="form-text text-muted">
                Оставьте пустым, если товара на сайте ещё нет - он будет создан. Укажите ID, если товар на сайте уже есть, чтобы не создать дубль.
            </small>
        </div>

        <!-- What the number points to -->
        <div v-if="result && result.shop" class="border rounded p-2 mb-2 small" :class="result.ok ? 'border-success' : 'border-danger'">
            <div><strong>{{ result.shop.name || '(без названия)' }}</strong></div>
            <div class="text-muted">
                Код: {{ result.shop.model || '—' }} · На сайте: {{ result.shop.status ? 'включён' : 'выключен' }} · Остаток на сайте: {{ result.shop.quantity }}
            </div>
        </div>
        <small v-if="result && result.error" class="form-text text-danger">{{ result.error }}</small>
        <small v-if="errors && errors.has && errors.has('opencart_id')" class="form-text text-danger" v-text="errors.get('opencart_id')"></small>
    </div>
</template>

<script>
export default {
    props: ['product', 'edit', 'errors'],
    data() {
        return {
            value: '',
            changing: false,
            result: null,
            busy: false,
        };
    },
    computed: {
        current() {
            return this.product && this.product.opencart_id ? this.product.opencart_id : null;
        },
        productId() {
            return this.edit ? this.$route.params.id : null;
        },
        config() {
            return { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } };
        },
    },
    methods: {
        onInput() {
            this.result = null;

            // On a new product the number goes with the form.
            if (!this.edit) {
                this.$set(this.product, 'opencart_id', this.value ? parseInt(this.value, 10) : null);
            }
        },
        startChange() {
            this.changing = true;
            this.value = '';
            this.result = null;
        },
        cancelChange() {
            this.changing = false;
            this.value = '';
            this.result = null;
        },
        check() {
            if (!this.value) return;
            this.busy = true;

            const params = this.productId ? { product_id: this.productId } : {};

            axios.get(`/api/admin/product/opencart-lookup/${parseInt(this.value, 10)}`, { ...this.config, params })
                .then(res => { this.result = res.data; })
                .catch(() => { this.result = { ok: false, error: 'Не удалось проверить товар на сайте.' }; })
                .finally(() => { this.busy = false; });
        },
        save() {
            const id = parseInt(this.value, 10);
            const name = this.result && this.result.shop ? this.result.shop.name : '';

            if (!confirm(`Связать этот товар с товаром сайта #${id} «${name}»?\n\nДанные товара на сайте (название, цены, статус, остаток) будут перезаписаны данными со склада.`)) {
                return;
            }

            this.busy = true;

            axios.put(`/api/admin/product/${this.productId}/opencart-id`, { opencart_id: id }, this.config)
                .then(res => {
                    this.$set(this.product, 'opencart_id', id);
                    this.changing = false;
                    this.value = '';
                    this.result = null;
                    this.$toaster.success(res.data.message || 'Связь сохранена');
                })
                .catch(error => {
                    const data = error.response && error.response.data;
                    this.result = { ...(this.result || {}), ok: false, error: (data && data.message) || 'Связь не сохранена.' };
                })
                .finally(() => { this.busy = false; });
        },
    },
};
</script>
